import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-liability-payment-reclassified-to-previous',
  templateUrl: './liability-payment-reclassified-to-previous.component.html',
  styleUrls: ['./liability-payment-reclassified-to-previous.component.scss'],
})
export class LiabilityPaymentReclassifiedToPreviousComponent {
  constructor() {}
}
